import { AutomateLabeling } from "@bimify-ab/labeling-tool";
import React, { useCallback } from "react";
import { baseURL } from "../../api";
import { getToken } from "../../utils/local-storage.util";
import { connect } from "react-redux";
import { updateExtractProgressLabelingTool } from "../../actions";
import config from "../../config";

const AutomateLabelingTool = ({
	activeExtractionJobId,
	updateExtractProgressLabelingTool,
}) => {
	const updateProgress = useCallback(
		(message, action) => {
			updateExtractProgressLabelingTool({ message, action });
		},
		[updateExtractProgressLabelingTool]
	);

	// Initiator gate: only the tab that clicked BIMIFY/Verify mounts the
	// labeling-tool socket subscription and uploads XML to DigitalOcean Spaces.
	// Other tabs receive the same broadcast events but must not duplicate work.
	if (activeExtractionJobId == null) return null;

	return (
		<AutomateLabeling
			baseURL={baseURL}
			socketURL={config.api.socketUrl}
			accessToken={getToken()}
			updateProgress={updateProgress}
		/>
	);
};

const mapStateToProps = (state) => ({
	activeExtractionJobId: state.getIn(["globalWidget", "activeExtractionJobId"]),
});

export default connect(mapStateToProps, { updateExtractProgressLabelingTool })(
	AutomateLabelingTool
);
